import { ModelBase } from 'store/model-base';

export class CmsAccessoryToast extends ModelBase {
    public static storeName: string = 'cmsAccessoryToast';

    public device: CmsAccessoryToastDetails;
    public accessory: CmsAccessoryToastDetails;
}
